// Module
var code = "<div ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"> <i class=\"material-icons close-modal no-expand\" ng-class=\"{show: hover}\" ng-click=\"$ctrl.closeModal($ctrl.card.id)\"> remove </i> <nets-call-wrapup card=\"$ctrl.card\" context=\"modal\"></nets-call-wrapup> </div> ";
// Exports
export default code;